import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { WalletValue, BbIcon, RobuxIcon, useAuth, BB_NAME, BB_CHIP } from '../context/AuthContext';
import { WalletModal } from './WalletModal';
import {
  User, Users, LogOut, Menu, X, ChevronDown,
  Bell, Trophy, ShieldCheck, Download, Upload, Gift, Clock,
  Flag, Gamepad2, Wallet, Plus, MessageCircle, Home as HomeIcon, Boxes,
  Check, Loader2, AlertTriangle
} from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';
const API = `${BACKEND_URL}/api`;

// ⚠️ Dashboard / LiveChat / Home ile AYNI palet ve AYNI
// formül. Header tek yerde SABİT bir gradyan kullanıyordu; aynı kullanıcı
// başlıkta bir renk, sohbette başka bir renk alıyordu.
const getAvatarColor = (username) => {
  const colors = [
    'from-purple-500 to-rose-500', 'from-purple-500 to-indigo-500',
    'from-blue-500 to-cyan-500', 'from-green-500 to-green-500',
    'from-orange-500 to-amber-500', 'from-red-500 to-purple-500',
  ];
  return colors[username?.charCodeAt(0) % colors.length || 0];
};

// ==========================================
// BAKİYE BİÇİMLENDİRİCİ
// ==========================================
const formatBalance = (amount) => {
  if (amount === undefined || amount === null) return '0';
  // ⚠️ TAM SAYI. Kesirli bakiye ham yazıldığında "545.5" gibi görünüyordu.
  // AŞAĞI yuvarlanır: sahip olunandan fazlasını göstermek, kullanıcıyı
  // harcayamayacağı bir tutara güvendirmek olurdu.
  const a = Math.floor(Number(amount) || 0);
  if (a >= 1000000) return a.toLocaleString();
  if (a >= 1000) return (a / 1000).toFixed(2).replace(/\.00$/, '') + 'K';
  return String(a);
};

const Diamond = ({ size = 14 }) => (
  <span
    className="block rotate-45 rounded-[2px] shrink-0"
    style={{ width: size, height: size, background: 'linear-gradient(135deg, #d29bff 0%, #B059E8 45%, #7b2fc4 100%)', boxShadow: '0 0 8px rgba(176,89,232,0.7)' }}
  />
);

// 🪙 BB Coin simgesi TEK KAYNAKTAN gelir (AuthContext.BbIcon).
// Header'ın kendi kopyası kaldırıldı: aynı ekranda iki farklı BB
// simgesi (biri "B" biri "BB") yan yana duruyordu.

// ══════════════════════════════════════════════════════════════════════
// 🍀 CÜZDAN SEÇİCİ — TEK SEÇİM NOKTASI
// ══════════════════════════════════════════════════════════════════════
// Seçim KULLANICI düzeyindedir (users.active_wallet), oyun düzeyinde değil.
// Bu yüzden header'da tek bir yerde durur; oyun sayfaları aktif cüzdanı
// yalnızca OKUR, seçtirmez.
const WalletSwitcher = ({ compact = false, onOpenWallet, balanceChange }) => {
  const { wallet, isLc, balance: activeBalance, siteBalance, lcBalanceMilli,
          switchWallet, switchingWallet, walletAmount: fmt, fmtMoney } = useAuth();
  const [open, setOpen] = useState(false);
  const [err, setErr] = useState(null);
  const boxRef = useRef(null);

  useEffect(() => {
    const onDoc = (e) => { if (boxRef.current && !boxRef.current.contains(e.target)) { setOpen(false); setErr(null); } };
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, []);

  const pick = async (w) => {
    setErr(null);
    const res = await switchWallet(w);
    if (res.ok) { setOpen(false); return; }
    if (res.error === 'busy') return;
    // ⚠️ HATA MUTLAKA GÖSTERİLMELİ. Sunucu 409 (açık oyun), 503 (bakım) ya da
    // 403 (hesap incelemede) döndürebilir. Sessizce yutulursa kullanıcı
    // butona basar, hiçbir şey olmaz ve sebebini asla öğrenemez.
    setErr(res.error || 'Wallet could not be switched.');
  };

  const opts = [
    // ⚠️ id'ler ('main'/'lc') BACKEND SÖZLEŞMESİDİR, değişmez; yalnızca
    // etiketler marka adı. Site parası kullanıcıya "Robux" olarak görünür.
    { id: 'main', label: 'MM Coin', amount: siteBalance,    icon: <RobuxIcon size={26} />,
      hint: 'Deposit & withdraw with MM2 items' },
    { id: 'lc',   label: BB_NAME, amount: lcBalanceMilli, icon: <BbIcon size={26} />,
      hint: 'Deposit & withdraw with crypto' },
  ];

  return (
    <div className="relative" ref={boxRef}>
      {/* TEK KUTU, İKİ BÖLGE — kullanıcı ne yaptığını konumdan anlar. */}
      <div
        data-testid="balance-display"
        className={`flex items-stretch rounded-lg bg-[#15171a] border overflow-hidden transition-colors ${
          balanceChange === 'increase' ? 'border-green-500'
          : balanceChange === 'decrease' ? 'border-red-500' : 'border-[#2A2D31]'} ${compact ? 'h-8' : 'h-9 md:h-10'}`}
      >
        {/* SOL: ok + tutar → cüzdan menüsü */}
        <button type="button" onClick={() => setOpen(o => !o)}
          data-testid="wallet-switcher" title="Switch wallet"
          className={`flex items-center gap-2 hover:bg-white/5 transition-colors ${compact ? 'pl-2 pr-2' : 'pl-2.5 pr-3'}`}>
          {switchingWallet
            ? <Loader2 className="w-3.5 h-3.5 text-zinc-400 animate-spin shrink-0" />
            : <ChevronDown className={`w-3.5 h-3.5 text-zinc-500 transition-transform shrink-0 ${open ? 'rotate-180' : ''}`} />}
          {/* ⚠️ Birim işareti TEK: WalletValue rakamın yanına BB coinini
              (ya da site tarafında "$") kendisi koyuyor. Ayrıca bir ikon
              daha çizmek "🪙 1.457 🪙" gibi tekrar üretiyordu. */}
          <span className={`mm-num font-bold text-white leading-none whitespace-nowrap ${compact ? 'text-xs' : 'text-sm md:text-base'}`}>
            <WalletValue amount={activeBalance} wallet={wallet}
                         size={compact ? 14 : 18} />
          </span>
        </button>

        {/* SAĞ: cüzdan ikonu → Wallet modalı. Ayrı bölge olması şart:
            aynı butona basınca hem menü hem modal açılamaz. */}
        <button type="button" onClick={() => { setOpen(false); onOpenWallet?.(); }}
          data-testid="wallet-open-btn" title="Wallet"
          aria-label="Open wallet"
          className={`flex items-center justify-center bg-[#16A34A] hover:bg-[#15913f] text-white transition-colors ${compact ? 'w-8' : 'w-9 md:w-10'}`}>
          <Wallet className="w-4 h-4" />
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div initial={{ opacity: 0, y: -6 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -6 }}
            transition={{ duration: 0.15 }}
            className="mm-panel mm-chroma-edge absolute right-0 top-full mt-2 w-64 z-[60] overflow-hidden">
            <div className="px-3 py-2 border-b border-[#2A2D31]">
              <p className="mm-eyebrow">Active wallet</p>
            </div>
            {opts.map(o => {
              const active = wallet === o.id;
              return (
                <button key={o.id} type="button" disabled={switchingWallet} onClick={() => pick(o.id)}
                  data-testid={`wallet-opt-${o.id}`}
                  className={`w-full flex items-center gap-3 px-3 py-3 text-left transition-colors disabled:opacity-50 border-l-2 ${
                    active ? 'bg-white/5 border-l-[#16A34A]' : 'border-l-transparent hover:bg-white/5'}`}>
                  <span className="shrink-0">{o.icon}</span>
                  <span className="flex-1 min-w-0">
                    <span className="flex items-baseline gap-2">
                      <span className="text-sm font-bold text-white truncate">{o.label}</span>
                      {/* ⚠️ Tutar KENDİ biriminde: mili-LC → BB'ye çevrilir. */}
                      {/* Metin "BB" yerine coin — listede de tutarlı. */}
                      <span className="text-[11px] mm-num text-zinc-300 ml-auto">
                        <WalletValue amount={o.amount} wallet={o.id} size={15} />
                      </span>
                    </span>
                    <span className="block text-[10px] text-zinc-500 mt-0.5 truncate">{o.hint}</span>
                  </span>
                  {active && <Check className="w-4 h-4 text-green-400 shrink-0" />}
                </button>
              );
            })}
            {err && (
              <div className="flex items-start gap-2 px-3 py-2.5 bg-red-500/10 border-t border-red-500/20">
                <AlertTriangle className="w-3.5 h-3.5 text-red-400 mt-0.5 shrink-0" />
                <span className="text-[11px] text-red-300 leading-snug">{err}</span>
              </div>
            )}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

const GAME_LINKS = [
  { name: 'Cases', path: '/cases' },
  { name: 'Case Battles', path: '/battles' },
  { name: 'Crash', path: '/crash' },
  { name: 'Roulette', path: '/roulette' },
  { name: 'Blackjack', path: '/blackjack' },
  { name: 'Towers', path: '/tower' },
  { name: 'Plinko', path: '/plinko' },
  { name: 'Dice', path: '/dice' },
  { name: 'Mines', path: '/mines' },
  { name: 'Jackpot', path: '/jackpot' },
  { name: 'Coinflip', path: '/coinflip' },
  { name: 'Chicken Road', path: '/chicken-road' },
];

export const Header = () => {
  const { user, isAuthenticated, logout, balanceChange, token, refreshUser,
          wallet, isLc, balance: activeBalance, fmtMoney } = useAuth();

  /* ── BAKİYE CANLI TUTULUR ──
     Bahis, bahşiş, yatırım kredisi ve çekim iadesi bakiyeyi SUNUCUDA
     değiştiriyor; arayüzün haberi olmuyordu. Kullanıcı üstteki rakamın
     eskidiğini fark edince sayfayı yeniliyor ya da parasının kaybolduğunu
     sanıyordu.

     ⚠️ SEKME GİZLİYKEN YOKLAMA YOK. Arka planda açık duran onlarca sekme,
     hiç kimse bakmıyorken sunucuya sürekli istek atardı. Sekme geri
     görünür olduğunda ANINDA bir kez tazeliyoruz — kullanıcının ilk
     gördüğü rakam güncel olsun. */
  useEffect(() => {
    if (!isAuthenticated || typeof refreshUser !== 'function') return;

    let timer = null;
    const tick = () => { if (!document.hidden) refreshUser(); };
    const start = () => {
      if (timer) return;
      timer = setInterval(tick, 15000);
    };
    const stop = () => { if (timer) { clearInterval(timer); timer = null; } };

    const onVisible = () => {
      if (document.hidden) { stop(); }
      else { refreshUser(); start(); }
    };

    if (!document.hidden) start();
    document.addEventListener('visibilitychange', onVisible);
    return () => { stop(); document.removeEventListener('visibilitychange', onVisible); };
  }, [isAuthenticated, refreshUser]);
  const navigate = useNavigate();

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  // Roblox avatarı yüklenemezse baş harfe düş. Kullanıcı Roblox adını
  // değiştirdiğinde sıfırlanır, yoksa bir kez patlayan avatar bir daha denenmez.
  const [avatarFailed, setAvatarFailed] = useState(false);
  useEffect(() => { setAvatarFailed(false); }, [user?.roblox_username]);
  const [walletOpen, setWalletOpen] = useState(false);
  const [walletTab, setWalletTab] = useState('deposit');

  // Cüzdanı belirli bir sekmede açar (deposit / withdraw / tip / promo)
  const openWallet = (tab = 'deposit') => {
    setWalletTab(tab);
    setWalletOpen(true);
  };

  // Giriş/Kayıt artık ayrı sayfa değil — global event ile modal açılır (App.js dinler).
  const openAuth = (tab = 'login') => window.dispatchEvent(new CustomEvent('donut:auth', { detail: { tab } }));

  const [notificationsOpen, setNotificationsOpen] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [loadingNotifications, setLoadingNotifications] = useState(false);
  const notifRef = useRef(null);

  const handleLogout = () => {
    logout();
    navigate('/');
    setMobileMenuOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (notifRef.current && !notifRef.current.contains(event.target)) {
        setNotificationsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const fetchNotifications = async () => {
    if (!isAuthenticated || !token) return;
    setLoadingNotifications(true);
    try {
      const response = await axios.get(`${API}/transactions`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const filtered = response.data.filter(t =>
        ['deposit', 'withdraw', 'tip_received', 'tip_sent'].includes(t.type)
      );
      setNotifications(filtered.slice(0, 5));
    } catch (error) {
      console.error("Failed to fetch notifications:", error);
    } finally {
      setLoadingNotifications(false);
    }
  };

  const toggleNotifications = () => {
    const willOpen = !notificationsOpen;
    setNotificationsOpen(willOpen);
    if (willOpen) fetchNotifications();
  };

  const getNotificationIcon = (type) => {
    switch (type) {
      case 'deposit': return <Download className="w-4 h-4 text-green-400" />;
      case 'withdraw': return <Upload className="w-4 h-4 text-rose-400" />;
      case 'tip_received': return <Gift className="w-4 h-4 text-amber-400" />;
      case 'tip_sent': return <Gift className="w-4 h-4 text-zinc-400" />;
      default: return <Bell className="w-4 h-4 text-[#c98bf0]" />;
    }
  };

  const getNotificationText = (notif) => {
    // ⚠️ BİLDİRİM KENDİ CÜZDANINI TAŞIR. Bahşiş ve kripto işlemleri iki
    // cüzdanda da olabiliyor; backend işlem kaydına `wallet` yazıyor.
    // Sabit "$" yazmak 1.000.000 mili-LC'lik ($1) bir işlemi "1M$" gösterirdi.
    const amountStr = fmtMoney(notif.amount, notif.wallet);
    switch (notif.type) {
      case 'deposit':
        return <><span className="text-green-400 font-bold">+{amountStr}</span> Deposit <span className="text-[10px] text-zinc-500 uppercase">({notif.status})</span></>;
      case 'withdraw':
        return <><span className="text-rose-400 font-bold">-{amountStr}</span> Withdraw <span className="text-[10px] text-zinc-500 uppercase">({notif.status})</span></>;
      case 'tip_received':
        return <><span className="text-amber-400 font-bold">+{amountStr}</span> {notif.roblox_username}</>;
      case 'tip_sent':
        return <><span className="text-zinc-400 font-bold">-{amountStr}</span> {notif.roblox_username}</>;
      default:
        return "Transaction recorded";
    }
  };

  const formatTimeAgo = (dateString) => {
    const diff = Math.floor((new Date() - new Date(dateString)) / 60000);
    if (diff < 1) return 'Just now';
    if (diff < 60) return `${diff}m ago`;
    if (diff < 1440) return `${Math.floor(diff / 60)}h ago`;
    return `${Math.floor(diff / 1440)}d ago`;
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-[#1F2225] border-b border-[#2A2D31]">
      {/* ⚠️ `max-w-[1800px] mx-auto` KALDIRILDI.
          Header çubuğu ekranın tamamına yayılıyor ama içeriği 1800px'te
          sınırlanıp ORTALANIYORDU. 1800px'ten geniş bir monitörde bu, sol
          gruptaki logonun ekranın en solunda değil (genişlik−1800)/2 kadar
          içeride durması demek — sağ grup için de aynısı. Dar ekranda fark
          edilmiyor, geniş ekranda çubuk boşta duruyormuş gibi görünüyor.

          Artık tam genişlik. Yatay dolgu büyük ekranda biraz açılıyor
          (px-3 → px-6): öğeler cama yapışmasın ama kenardan konum alsın.

          ⚠️ SONUÇ: çok geniş ekranda header öğeleri, sayfa içeriğinin
          1800px'lik sütununun DIŞINDA kalır. Bu bilinçli — gezinti
          çubuklarının tam genişlikte olması yaygın ve doğru olan desen;
          sütuna hizalamak isterseniz max-w'yi geri koyup değerini
          yükseltmek gerekir. */}
      <div className="w-full px-3 md:px-5 lg:px-6">
        <div className="relative flex items-center justify-between h-16 md:h-20">

          {/* ================= SOL ================= */}
          <div className="flex items-center gap-2 md:gap-2.5">
            <button
              className="lg:hidden p-2 text-zinc-400 hover:text-white"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>

            {/* ⚠️ gap-2 (8px) FAZLAYDI. logo.png'nin kendi içinde de boşluğu var,
                yani görünen aralık 8px değil daha genişti ve marka iki ayrı
                parça gibi duruyordu. gap-1 + negatif harf aralığı yerine
                doğrudan 4px: logo ile yazı tek bir işaret olarak okunuyor. */}
            {/* ⚠️ `hidden sm:flex` → `flex`. Logo 640px altında TAMAMEN
                gizliydi; "her cihazda dönsün" isteği mobilde karşılanamazdı
                çünkü logo orada hiç yoktu. Artık her genişlikte görünüyor. */}
            <Link to="/" className="flex items-center gap-1 group mr-1" data-testid="logo-link">
              <img
                src="/logo.png"
                alt="Logo"
                /* ⚠️ BOYUT: 32/36px → 40/48px.
                   Üst sınır header yüksekliği (h-16 md:h-20 = 64/80px);
                   48px, masaüstünde üstte altta 16'şar piksel bırakıyor.
                   Daha büyüğü logoyu çubuğa yapıştırır.

                   ⚠️ DÖNÜŞ ARTIK DOKUNMATİKTE DE ÇALIŞIYOR. `group-hover`
                   tek başına yetmiyordu: dokunmatik ekranda hover diye bir
                   durum yok, parmak basıldığında tarayıcı kalıcı bir hover
                   uydurmaya çalışıyor ve sonuç cihazdan cihaza değişiyor.
                   `group-active` basma anını yakalıyor, `group-focus`
                   klavyeyle sekmeyle gelen kullanıcıyı. Üçü birlikte:
                   fare, dokunma ve klavye. */
                className="logo-spin w-9 h-9 md:w-11 md:h-11 object-contain
                           transition-transform duration-500 ease-in-out
                           group-hover:rotate-[360deg]
                           group-focus:rotate-[360deg]
                           group-active:rotate-[360deg]"
              />
              <span className="hidden 2xl:inline font-heading font-bold text-lg tracking-wide text-white -ml-0.5">
                BLOX<span className="text-[#B059E8]">BETS</span>
              </span>
            </Link>

            <div className="relative group hidden lg:block">
              <button className="flex items-center gap-1.5 px-3 h-9 rounded-lg text-zinc-300 hover:text-white hover:bg-white/5 font-bold text-sm transition-colors">
                <Gamepad2 className="w-4 h-4" /> Games
                <ChevronDown className="w-4 h-4 text-zinc-500 group-hover:rotate-180 transition-transform duration-200" />
              </button>
              <div className="absolute left-0 top-full pt-2 w-52 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50">
                <div className="py-2 bg-[#15171a] border border-[#2A2D31] rounded-xl shadow-2xl">
                  {GAME_LINKS.map((g) => (
                    <Link key={g.path} to={g.path} className="block px-4 py-2 text-sm text-zinc-300 hover:text-white hover:bg-white/5 transition-colors">
                      {g.name}
                    </Link>
                  ))}
                </div>
              </div>
            </div>

            <Link to={isAuthenticated && user?.used_affiliate ? '/rakeback' : '/affiliates'} className="shrink-0">
              <button className="flex items-center gap-1.5 md:gap-2 h-9 md:h-10 px-2.5 md:px-4 rounded-lg bg-[#16A34A] hover:bg-[#15913f] text-white font-bold text-xs md:text-sm shadow-[0_0_14px_rgba(22,163,74,0.4)] transition-all hover:scale-[1.02] whitespace-nowrap">
                <Gift className="w-4 h-4 shrink-0" />
                {isAuthenticated && user?.used_affiliate ? (
                  <span>Rewards</span>
                ) : (
                  <>
                    <span className="hidden sm:inline">Claim Free $5</span>
                    <span className="sm:hidden">Free $5</span>
                  </>
                )}
              </button>
            </Link>

            <Link
              to="/race"
              title="Daily Race"
              className="hidden sm:flex items-center gap-2 h-9 md:h-10 px-3 rounded-lg bg-[#2A2D31]/60 border border-[#2A2D31] text-amber-400 hover:text-amber-300 hover:border-amber-500/40 font-bold text-xs md:text-sm transition-colors"
            >
              <Flag className="w-4 h-4" />
              <span>Race</span>
            </Link>
          </div>

          {/* ================= ORTA: Bakiye ================= */}
          {isAuthenticated && (
            <motion.div
              animate={balanceChange ? { scale: [1, 1.05, 1] } : {}}
              transition={{ duration: 0.3 }}
              className="absolute left-1/2 -translate-x-1/2 hidden md:flex items-center"
            >
              {/* 🍀 Bakiye + cüzdan seçimi TEK KUTUDA. Sol bölge menüyü,
                  sağdaki yeşil ikon Wallet modalını açar. */}
              <WalletSwitcher onOpenWallet={() => openWallet('deposit')} balanceChange={balanceChange} />
            </motion.div>
          )}

          {/* ================= SAĞ ================= */}
          <div className="flex items-center gap-2 md:gap-2.5">
            {isAuthenticated ? (
              <>
                {/* MOBİL: aynı birleşik kutu (dar mod) */}
                <div className="flex md:hidden" data-testid="wallet-btn-mobile">
                  <WalletSwitcher compact onOpenWallet={() => openWallet('deposit')} balanceChange={balanceChange} />
                </div>

                {/* MASAÜSTÜ: Deposit butonu */}
                <button
                  onClick={() => openWallet('deposit')}
                  data-testid="wallet-btn"
                  className="hidden md:flex items-center gap-1 h-9 md:h-10 px-3 md:px-5 rounded-lg bg-[#16A34A] hover:bg-[#15913f] text-white font-bold text-xs md:text-sm shadow-[0_0_14px_rgba(22,163,74,0.4)] transition-all hover:scale-[1.02]"
                >
                  <Plus className="w-4 h-4" /> Deposit
                </button>

                <button
                  onClick={() => openWallet('withdraw')}
                  className="hidden sm:block h-9 md:h-10 px-3 md:px-5 rounded-lg bg-[#2A2D31] hover:bg-[#3a3d43] text-zinc-200 font-bold text-xs md:text-sm border border-[#3a3d43] transition-colors"
                >
                  Withdraw
                </button>

                <div className="relative" ref={notifRef}>
                  <button
                    onClick={toggleNotifications}
                    className={`p-2 relative rounded-lg transition-colors ${notificationsOpen ? 'bg-[#2A2D31] text-white' : 'text-zinc-400 hover:text-white hover:bg-white/5'}`}
                  >
                    <Bell className="w-5 h-5" />
                    <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-[#B059E8] rounded-full shadow-[0_0_8px_rgba(176,89,232,0.8)]" />
                  </button>

                  <AnimatePresence>
                    {notificationsOpen && (
                      <motion.div
                        initial={{ opacity: 0, y: 10, scale: 0.95 }}
                        animate={{ opacity: 1, y: 0, scale: 1 }}
                        exit={{ opacity: 0, y: 10, scale: 0.95 }}
                        transition={{ duration: 0.15 }}
                        className="absolute right-0 top-full mt-3 w-72 md:w-80 bg-[#15171a] border border-[#2A2D31] rounded-xl shadow-2xl z-50 overflow-hidden"
                      >
                        <div className="p-3 border-b border-[#2A2D31] bg-[#1F2225] flex items-center justify-between">
                          <h3 className="text-white font-bold text-sm">Recent Transactions</h3>
                          <Clock className="w-4 h-4 text-zinc-500" />
                        </div>
                        <div className="max-h-[320px] overflow-y-auto custom-scrollbar">
                          {loadingNotifications ? (
                            <div className="p-6 flex flex-col items-center justify-center gap-2 text-zinc-400">
                              <div className="w-6 h-6 border-2 border-[#B059E8] border-t-transparent rounded-full animate-spin"></div>
                              <span className="text-xs font-bold uppercase tracking-widest">Loading...</span>
                            </div>
                          ) : notifications.length > 0 ? (
                            notifications.map((notif) => (
                              <div key={notif.id} className="p-3 border-b border-[#2A2D31] last:border-0 hover:bg-[#23262a] transition-colors flex items-start gap-3">
                                <div className="p-2 rounded-lg bg-[#121417] border border-[#2A2D31] flex-shrink-0 shadow-inner">
                                  {getNotificationIcon(notif.type)}
                                </div>
                                <div className="flex-1 min-w-0">
                                  <p className="text-sm text-zinc-300 truncate">{getNotificationText(notif)}</p>
                                  <p className="text-xs text-zinc-500 mt-1">{formatTimeAgo(notif.created_at)}</p>
                                </div>
                              </div>
                            ))
                          ) : (
                            <div className="p-6 text-center">
                              <div className="w-10 h-10 rounded-full bg-[#121417] border border-[#2A2D31] flex items-center justify-center mx-auto mb-3">
                                <Bell className="w-4 h-4 text-zinc-600" />
                              </div>
                              <p className="text-zinc-500 text-sm">No recent transactions found.</p>
                            </div>
                          )}
                        </div>
                        <div className="p-2 border-t border-[#2A2D31] bg-[#1F2225]">
                          <Link to="/dashboard" onClick={() => setNotificationsOpen(false)} className="block w-full text-center py-1.5 text-xs font-bold text-[#c98bf0] hover:text-[#d8b8f0] uppercase tracking-widest transition-colors">
                            View All History
                          </Link>
                        </div>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>

                <div className="relative group">
                  <button className="flex items-center gap-1.5 p-1 rounded-lg text-zinc-300 hover:text-white hover:bg-white/5 transition-colors" data-testid="user-menu-btn">
                    {/* ⚠️ TEK SATIRLIK GERÇEK HATA BURADAYDI.
                        Koşul `user?.site_username` idi; giriş yapmış HER
                        kullanıcıda doğru olduğu için alttaki baş harf dalı
                        ÖLÜ KODDU. Roblox hesabı olmayan kullanıcı için bile
                        avatar isteği atılıyor, sonra kırık görsele düşülüyordu.
                        Doğru koşul: Roblox adı bağlı mı? */}
                    {user?.roblox_username && !avatarFailed ? (
                      <div className="w-8 h-8 md:w-9 md:h-9 rounded-lg border border-[#B059E8]/40 bg-[#121417] overflow-hidden flex items-center justify-center shadow-lg">
                        {/* ⚠️ Eski hali hatada görseli GİZLİYORDU (display:none)
                            ve geriye BOŞ KUTU kalıyordu. Roblox avatarı
                            moderasyonda ya da henüz üretilmemişse kullanıcı
                            kendini kimliksiz görüyordu. Baş harfe düşülür. */}
                        <img
                          src={`${API}/user/avatar/${user?.site_username}?v=${encodeURIComponent(user?.roblox_username || '')}`}
                          alt="Profile"
                          className="w-full h-full object-cover"
                          onError={() => setAvatarFailed(true)}
                        />
                      </div>
                    ) : (
                      <div className={`w-8 h-8 md:w-9 md:h-9 rounded-lg bg-gradient-to-br ${getAvatarColor(user?.site_username)} flex items-center justify-center shadow-lg`}>
                        <span className="text-white text-xs md:text-sm font-bold">{user?.site_username?.charAt(0).toUpperCase()}</span>
                      </div>
                    )}
                    <ChevronDown className="w-4 h-4 text-zinc-400 hidden sm:block" />
                  </button>

                  <div className="absolute right-0 top-full pt-2 w-52 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50">
                    <div className="py-2 bg-[#15171a] border border-[#2A2D31] rounded-xl shadow-2xl">
                      <div className="px-4 py-2 border-b border-[#2A2D31] mb-1">
                        <p className="text-white font-bold text-sm truncate">{user?.site_username}</p>
                        {/* İki cüzdan da görünür; aktif olan vurgulanır. */}
                        <p className={`text-[11px] mm-num flex items-center gap-1 ${!isLc ? 'text-white' : 'text-zinc-500'}`}>
                          <WalletValue amount={user?.balance || 0} wallet={'main'} size={11} />
                        </p>
                        <p className={`text-[11px] mm-num flex items-center gap-1 ${isLc ? 'text-[#F5B700]' : 'text-zinc-500'}`}>
                          <WalletValue amount={user?.lc_balance_milli || 0} wallet={'lc'} size={11} />
                        </p>
                      </div>
                      <Link to="/dashboard" className="flex items-center gap-3 px-4 py-2 text-sm text-zinc-300 hover:text-white hover:bg-white/5" data-testid="dropdown-dashboard">
                        <User className="w-4 h-4" /> My Profile
                      </Link>
                      <Link to="/affiliates" className="flex items-center gap-3 px-4 py-2 text-sm text-zinc-300 hover:text-[#c98bf0] hover:bg-[#B059E8]/10 transition-colors">
                        <Users className="w-4 h-4" /> Affiliates
                      </Link>
                      <Link to="/rakeback" className="flex items-center gap-3 px-4 py-2 text-sm text-zinc-300 hover:text-[#c98bf0] hover:bg-[#B059E8]/10 transition-colors">
                        <Gift className="w-4 h-4" /> Rakeback Rewards
                      </Link>
                      <Link to="/race" className="flex items-center gap-3 px-4 py-2 text-sm text-zinc-300 hover:text-amber-400 hover:bg-amber-500/10 transition-colors">
                        <Trophy className="w-4 h-4" /> Daily Race
                      </Link>
                      <Link to="/communitycases" className="flex items-center gap-3 px-4 py-2 text-sm text-zinc-300 hover:text-[#c98bf0] hover:bg-[#B059E8]/10 transition-colors">
                        <Boxes className="w-4 h-4" /> Community Cases
                      </Link>
                      <hr className="my-2 border-[#2A2D31]" />
                      <button onClick={handleLogout} className="flex items-center gap-3 px-4 py-2 text-sm text-red-400 hover:text-red-300 hover:bg-red-500/10 w-full" data-testid="dropdown-logout">
                        <LogOut className="w-4 h-4" /> Log Out
                      </button>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <>
                <button
                  onClick={() => openAuth('register')}
                  data-testid="register-link"
                  className="h-9 md:h-10 px-4 md:px-6 rounded-lg text-white font-black text-xs md:text-sm relative overflow-hidden shadow-[0_0_14px_rgba(176,89,232,0.4)] transition-all hover:scale-[1.02]"
                  style={{ background: '#B059E8' }}
                >
                  <span className="absolute inset-0" style={{ backgroundImage: 'repeating-linear-gradient(45deg, rgba(0,0,0,0.18) 0px, rgba(0,0,0,0.18) 9px, transparent 9px, transparent 20px)' }} />
                  <span className="relative">Register</span>
                </button>

                <button
                  onClick={() => openAuth('login')}
                  data-testid="login-link"
                  className="h-9 md:h-10 px-4 md:px-6 rounded-lg bg-[#16A34A] hover:bg-[#15913f] text-white font-bold text-xs md:text-sm shadow-[0_0_14px_rgba(22,163,74,0.4)] transition-all hover:scale-[1.02]"
                >
                  Login
                </button>

                <div className="relative group hidden sm:block">
                  <button className="h-9 md:h-10 w-9 md:w-10 flex items-center justify-center rounded-lg bg-[#2A2D31] hover:bg-[#3a3d43] border border-[#3a3d43] text-zinc-300 hover:text-white transition-colors">
                    <ChevronDown className="w-4 h-4 group-hover:rotate-180 transition-transform duration-200" />
                  </button>
                  <div className="absolute right-0 top-full pt-2 w-56 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50">
                    <div className="py-2 bg-[#15171a] border border-[#2A2D31] rounded-xl shadow-2xl">
                      <Link to="/rakeback" className="flex items-center gap-3 px-4 py-2.5 text-sm text-zinc-300 hover:text-[#16A34A] hover:bg-[#16A34A]/10 transition-colors">
                        <Gift className="w-4 h-4" /> Rewards
                      </Link>
                      <Link to="/fairness" className="flex items-center gap-3 px-4 py-2.5 text-sm text-zinc-300 hover:text-green-400 hover:bg-green-500/10 transition-colors">
                        <ShieldCheck className="w-4 h-4" /> Fairness
                      </Link>
                      <Link to="/race" className="flex items-center gap-3 px-4 py-2.5 text-sm text-zinc-300 hover:text-amber-400 hover:bg-amber-500/10 transition-colors">
                        <Trophy className="w-4 h-4" /> Daily Race
                      </Link>
                      <Link to="/affiliates" className="flex items-center gap-3 px-4 py-2.5 text-sm text-zinc-300 hover:text-[#c98bf0] hover:bg-[#B059E8]/10 transition-colors">
                        <Users className="w-4 h-4" /> Affiliates
                      </Link>
                      <Link to="/communitycases" className="flex items-center gap-3 px-4 py-2.5 text-sm text-zinc-300 hover:text-[#c98bf0] hover:bg-[#B059E8]/10 transition-colors">
                        <Boxes className="w-4 h-4" /> Community Cases
                      </Link>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      {/* ================= MOBİL MENÜ ================= */}
      <AnimatePresence>
        {mobileMenuOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            className="lg:hidden bg-[#1F2225] border-t border-[#2A2D31] overflow-hidden"
          >
            <nav className="p-4 space-y-1.5">
              {/* ANA SAYFA VE CHAT BUTONLARI (Yeni eklendi) */}
              <Link to="/" onClick={() => setMobileMenuOpen(false)} className="flex items-center gap-2 px-4 py-3 text-zinc-300 hover:text-white bg-white/5 hover:bg-white/10 rounded-lg transition-colors font-bold mb-1">
                <HomeIcon className="w-5 h-5" /> Home
              </Link>
              <button
                onClick={() => {
                  window.dispatchEvent(new CustomEvent('toggleMobileChat'));
                  setMobileMenuOpen(false);
                }}
                className="flex items-center gap-2 px-4 py-3 text-zinc-300 hover:text-white bg-white/5 hover:bg-white/10 rounded-lg transition-colors font-bold w-full text-left mb-3"
              >
                <MessageCircle className="w-5 h-5" /> Toggle Chat
              </button>

              <div className="px-2 pb-1 text-[10px] font-black uppercase tracking-widest text-zinc-600">Games</div>
              <div className="grid grid-cols-2 gap-1.5 mb-2">
                {GAME_LINKS.map((g) => (
                  <Link key={g.path} to={g.path} onClick={() => setMobileMenuOpen(false)} className="px-3 py-2.5 text-sm text-zinc-300 hover:text-white bg-white/5 hover:bg-white/10 rounded-lg transition-colors">
                    {g.name}
                  </Link>
                ))}
              </div>

              <Link to="/rakeback" onClick={() => setMobileMenuOpen(false)} className="flex items-center gap-2 px-4 py-3 text-[#16A34A] font-bold bg-[#16A34A]/10 rounded-lg">
                <Gift className="w-5 h-5" /> Rewards
              </Link>
              <Link to="/race" onClick={() => setMobileMenuOpen(false)} className="flex items-center gap-2 px-4 py-3 text-amber-400 hover:bg-amber-500/10 rounded-lg font-bold">
                <Trophy className="w-5 h-5" /> Daily Race
              </Link>
              <Link to="/affiliates" onClick={() => setMobileMenuOpen(false)} className="flex items-center gap-2 px-4 py-3 text-[#c98bf0] hover:bg-[#B059E8]/10 rounded-lg font-bold">
                <Users className="w-5 h-5" /> Affiliates
              </Link>
              <Link to="/fairness" onClick={() => setMobileMenuOpen(false)} className="flex items-center gap-2 px-4 py-3 text-green-400 hover:bg-green-500/10 rounded-lg font-bold">
                <ShieldCheck className="w-5 h-5" /> Fairness
              </Link>
              <Link to="/communitycases" onClick={() => setMobileMenuOpen(false)} className="flex items-center gap-2 px-4 py-3 text-[#c98bf0] hover:bg-[#B059E8]/10 rounded-lg font-bold">
                <Boxes className="w-5 h-5" /> Community Cases
              </Link>

              {isAuthenticated ? (
                <>
                  <Link to="/dashboard" onClick={() => setMobileMenuOpen(false)} className="flex items-center gap-2 px-4 py-3 text-zinc-300 hover:bg-white/5 rounded-lg">
                    <User className="w-5 h-5" /> My Profile
                  </Link>
                  <Link to="/withdraws" onClick={() => setMobileMenuOpen(false)} className="flex items-center gap-2 px-4 py-3 text-zinc-300 hover:bg-white/5 rounded-lg">
                    <Upload className="w-5 h-5" /> Withdraw
                  </Link>
                  <button onClick={handleLogout} className="flex items-center gap-2 w-full text-left px-4 py-3 text-red-400 hover:bg-red-500/10 rounded-lg">
                    <LogOut className="w-5 h-5" /> Log Out
                  </button>
                </>
              ) : (
                <div className="grid grid-cols-2 gap-2 mt-1">
                  <button onClick={() => { openAuth('register'); setMobileMenuOpen(false); }} className="block w-full text-center px-4 py-3 rounded-lg text-white font-black" style={{ background: '#B059E8' }}>
                    Register
                  </button>
                  <button onClick={() => { openAuth('login'); setMobileMenuOpen(false); }} className="block w-full text-center px-4 py-3 rounded-lg text-white font-black bg-[#16A34A]">
                    Login
                  </button>
                </div>
              )}
            </nav>
          </motion.div>
        )}
      </AnimatePresence>

      <WalletModal isOpen={walletOpen} onClose={() => setWalletOpen(false)} initialTab={walletTab} />
    </header>
  );
};